import React from 'react';

const ScreenShotTableRow = ({ item, handleScreenShotSelect, pathKeys, pathname }) => {
    return (
        <tr>
            {
                item[0]?.map((itemRow) => {
                    return (
                        <td className="v-middle" key={itemRow?.appUuid}>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={itemRow?.appUuid}
                                    name={itemRow?.appUuid}
                                    checked={itemRow[pathKeys[pathname]?.key]}
                                    onChange={handleScreenShotSelect}
                                />
                                <label
                                    className="form-check-label d-inline-flex align-items-center"
                                    htmlFor={itemRow?.appUuid}
                                >
                                    <span className="icon-wrap icon-sm me-2 p-0">
                                        <img
                                            src={itemRow?.image}
                                            alt="avatar"
                                        />
                                    </span>
                                    {itemRow?.app_name}
                                </label>
                            </div>
                        </td>
                    )
                })
            }
        </tr>
    )
}

export default ScreenShotTableRow